<!-- 广告组下拉 -->
<template>
<div>
	<a-select
		mode="multiple" 
		style="min-width: 260px;max-width: 600px;"
		placeholder="请选择广告组"
		:filter-option="false"
		@change="handleChangeC"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="popupScrollGGZ" 
		showSearch
		allowClear
		@search="selectGgzSearch"
		:not-found-content="ggz_fetching ? undefined : null" 
		@blur="ggzBlur"
	  >
		<a-spin v-if="ggz_fetching" slot="notFoundContent" size="small" />
		<a-select-option v-for="(item,index) in ggz_Select" :key="item.unit_id" :value="item.unit_id">
		  {{item.unit_name}}
		</a-select-option>
		<a-select-option v-if="ggz_loading_more_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
</div>
</template>

<script>
import { KSggzSelect } from '@/request/api'
export default {
	name: 'ggzSelect',
	props: ['page_type'],
	data(){
		return {
			// 广告组
			ggz_Select: [], // 选择广告组
			ggz_Blur: [], // 保存一份，用于失去焦点后，回复原来的数值
			ggz_page: 1,
			ggz_group_name: "", // 下拉选择框的搜索字段
			ggz_fetching: false, // 用于控制提示
			ggz_loading_more_control: true, // 上拉加载更多控制
			ggz_loading_more_hint: false, // 上拉加载更多的提示
			r_campaign_id: [], // 用于搜索请求
			// 广告组结束
		}
	},
	mounted(){
		let that = this
		
		// 广告组选择
		KSggzSelect({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			// console.log("获取广告组选择",res);
			that.ggz_Select = res.data.data.data
			that.ggz_Blur = res.data.data.data
		})
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 广告组部分
		handleChangeC(e){ // 选择广告组
			// console.log(e);
			this.r_campaign_id = e
			this.$emit('handle-change',e)
		},
		popupScrollGGZ(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.ggz_loading_more_control){ // 节流，保证这期间只执行一次
					this.ggz_loading_more_hint = true
					this.ggz_loading_more_control = false
					let that = this
					that.ggz_page = that.ggz_page + 1
					// console.log("上拉触底加载更多");
					KSggzSelect({
						page: that.ggz_page,
						limit: that.s_limit,
						group_name: that.ggz_group_name,
					}).then(res=>{
						// console.log('选择',res);
						
						let data = that.ggz_Select 
						that.ggz_loading_more_hint = false
						that.ggz_Select = data.concat(res.data.data.data) 
						that.ggz_fetching = false
						
						if(that.ggz_Select.length < res.data.data.total){
							that.ggz_loading_more_control = true
						}
					})
				}
			}
		},
		// 选择框搜索-选择广告组
		selectGgzSearch(e){
			// console.log("选择框搜索",e);
			let that = this
			that.ggz_Select = []
			that.ggz_fetching = true
			that.ggz_group_name = e
			
			KSggzSelect({
				page: 1,
				limit: that.s_limit,
				group_name: e,
			}).then(res=>{
				// console.log('选择',res);
				that.ggz_page = 1
				that.ggz_Select = res.data.data.data
				that.ggz_fetching = false
				
				if(that.ggz_Select.length < res.data.data.total){
					that.ggz_loading_more_control = true
				}
				else {
					that.ggz_loading_more_control = false
				}
			})
		},
		// 失去焦点
		ggzBlur(e){
			let that = this
			// console.log("失去焦点",e);
			that.ggz_page = 1
			that.ggz_group_name = '' // 清空
			that.ggz_Select = that.ggz_Blur 
			
			that.ggz_loading_more_control = true
		},
		// 广告组部分结束
	}
}
</script>

<style>
</style>